import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { RedeploymentOrderSearchResult } from '@shared/interfaces/gridrows/redeployment-order-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { FormGroup } from '@angular/forms';
import { BenchTemplateSearchResult } from '../../../shared/interfaces/gridrows/bench-template.interface';

@Injectable()
export class BenchTemplateService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) {

    //public state: State = { skip: 0, take: 100 };
  }

  getBenchTemplates(organizationId: number, securityId: number): Observable<Array<BenchTemplateSearchResult>> {
    var postData: { [k: string]: any } = {};
    postData['skip'] = 0;
    postData['take'] = 100;
    postData['organizationId'] = organizationId;
    postData['securityId'] = securityId;
    var url = this.urlHelper.getApiUrl() + "BenchTemplate";
    return this.http.post<Array<BenchTemplateSearchResult>>(url, postData);
  }

  saveBenchTemplateItem(price: BenchTemplateSearchResult): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "BenchTemplate/SaveBenchTemplateItem";
    return this.http.post<BooleanResult>(url, price);
  }

  setBenchTemplateStatus(benchTemplateId: number, benchTemplateStatusId: number): Observable<BooleanResult> {
    var postData: any = {};
    postData['benchTemplateId'] = benchTemplateId;
    postData['benchTemplateStatusId'] = benchTemplateStatusId

    var url = this.urlHelper.getApiUrl() + "BenchTemplate/SetBenchTemplateStatus";
    return this.http.post<BooleanResult>(url, postData);
  }

  reassignBenchTemplateItem(id: number, itemUniqueId: number): Observable<BooleanResult> {
    var postData: any = {};
    postData['id'] = id
    postData['itemUniqueId'] = itemUniqueId;

    var url = this.urlHelper.getApiUrl() + "BenchTemplate/ReassignBenchTemplateItem";
    return this.http.post<BooleanResult>(url, postData);
  }

  addItemBenchTemplate(id: number, itemUniqueIds: Array<number>): Observable<BooleanResult> {
    var postData: any = {};
    postData['id'] = id
    postData['itemUniqueIds'] = itemUniqueIds;

    var url = this.urlHelper.getApiUrl() + "BenchTemplate/AddItemBenchTemplate";
    return this.http.post<BooleanResult>(url, postData);
  }

  removeItemsFromBenchTemplate(id: number, itemUniqueIds: Array<number>): Observable<BooleanResult> {
    var postData: any = {};
    postData['id'] = id
    postData['itemUniqueIds'] = itemUniqueIds;

    var url = this.urlHelper.getApiUrl() + "BenchTemplate/RemoveItemsFromBenchTemplate";
    return this.http.post<BooleanResult>(url, postData);
  }

  saveBenchTemplateColumnOrder(columnOrder: string[]): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "BenchTemplate/SaveBenchTemplateColumnOrder/?columnOrder=" + columnOrder;
    return this.http.post<BooleanResult>(url, columnOrder);
  }

  getBenchTemplateColumnOrder(): Observable<string[]> {
    var url = this.urlHelper.getApiUrl() + "BenchTemplate/GetBenchTemplateColumnOrder/";
    return this.http.get<string[]>(url);
  }
}
